import stickySummary from '../components/plan-summary/sticky'
import store from 'utils/store/withMiddleware'

function deleteSupplemental(e) {
  const state = store.getState()
  store.update({
    addOns: state.addOns.filter(id => id != state.supplementalId),
    supplementalId: undefined
  })
  e.stopPropagation()
  e.preventDefault()
  stickySummary()
}

export default deleteSupplemental
